import { Typography } from "@mui/material";
import React, { useState } from "react";
import styles from "./devoteeManagement.module.scss";
import {
  CustomRequiredInputLabel,
  CustomTextFeild,
  CustomCheckbox,
  CustomInputLabel,
  CommonOutlinedButton,
  CommonButton,
  HcccCard,
} from "../common/StyledComponents/StyledFields";

const UnSubscribeComponent = () => {
  const [email, setEmail] = useState<string>("");
  const [weekly, setWeekly] = useState(true);
  const [birthday, setBirthday] = useState(true);
  const [emailError, setEmailError] = useState<string>("");

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
    setEmailError("");
  };

  const handleWeeklyChange = () => {
    setWeekly((prevWeekly) => !prevWeekly);
  };

  const handleBirthdayChange = () => {
    setBirthday((prevBirthday) => !prevBirthday);
  };

  const validateEmail = () => {
    // Simple email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email address");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validateEmail()) {
      // Perform the submit action here
      console.log("Submitting...");
    }
  };

  const handleCancel = () => {
    // Reset the fields
    setEmail("");
    setWeekly(true);
    setBirthday(true);
    setEmailError("");
  };

  const emailTextComponent = () => {
    return (
      <div className={styles.emailFeldContainer}>
        {CustomRequiredInputLabel("Email", true)}
        <CustomTextFeild
          value={email}
          onChange={handleEmailChange}
          error={!!emailError}
          helperText={emailError}
          sx={{ width: "60%" }}
          placeholder="Enter Email"
        />
      </div>
    );
  };

  const checkBoxComponent = () => {
    return (
      <div className={styles.checkboxContainer}>
        <CustomCheckbox checked={weekly} onChange={handleWeeklyChange} />
        <CustomInputLabel sx={{ marginTop: "auto", marginBottom: "auto" }}>
          Weekly E-mail
        </CustomInputLabel>
        <CustomCheckbox checked={birthday} onChange={handleBirthdayChange} />
        <CustomInputLabel sx={{ marginTop: "auto", marginBottom: "auto" }}>
          Birthday E-mail
        </CustomInputLabel>
      </div>
    );
  };

  const buttonsComponent = () => {
    return (
      <div className={styles.buttonContainer}>
        <CommonOutlinedButton onClick={handleCancel}>
          Cancel
        </CommonOutlinedButton>
        <CommonButton onClick={handleSubmit}>Submit</CommonButton>
      </div>
    );
  };

  const cardComponent = () => {
    return (
      <HcccCard>
        <Typography className={styles.subheading}>
          To unsubscribe from the HCCC, Livermore mailing list, please enter
          your e-mail address below and click "SUBMIT".
        </Typography>
        {emailTextComponent()}
        {checkBoxComponent()}
      </HcccCard>
    );
  };

  const render = () => {
    return (
      <div className={styles.unSubscribeContainer}>
        <Typography component={"h2"} className={styles.heading}>
          Unsubscribe
        </Typography>
        {cardComponent()}
        {buttonsComponent()}
      </div>
    );
  };

  return <div>{render()}</div>;
};

export default UnSubscribeComponent;
